import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../../assets/jss/Dialog";
import AppIcon from "../../../assets/images/praisoApp.png";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CustomDialog from "../../CustomComponents/CustomDialog/CustomDialog";
import theme from "../../../theme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CustomGrid from "../../CustomComponents/CustomGrid/CustomGrid";
import CustomDialogContent from "../../CustomComponents/CustomDialogContent/CustomDialogContent";
import CustomDialogTitle from "../../CustomComponents/CustomDialogTitle/CustomDialogTitle";
import { setSmartAppDialogState } from "../../../services/LocalStorageService";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import {
  detectBrowser,
  getMobileOperatingSystem,
} from "../../../config/app-global-method";
import CustomSlide from "../../CustomComponents/CustomSlide/CustomSlide";
import clsx from "clsx";
import { DeviceOS } from "../../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
const styles = (theme) => ({});

const DialogTitle = withStyles((theme) => ({}))(CustomDialogTitle);
const DialogContent = withStyles((theme) => ({}))(CustomDialogContent);
// const DialogActions = withStyles((theme) => ({}))(CustomDialogAction);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <CustomSlide direction="up" ref={ref} {...props} />;
});

export default function SmartAppDialog(props) {
  const { t } = useTranslation();

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [deviceOS] = React.useState(getMobileOperatingSystem);
  const [browserData] = React.useState(detectBrowser);
  const handleClose = (status?: boolean) => {
    setSmartAppDialogState({
      isOpen: status ? status : false
    });
    setOpen(false);
  };
  const navigateToApp = () => {
    if (deviceOS) {
      let redirectionLink;
      if (deviceOS === DeviceOS.ANDROID) {
        redirectionLink = process.env.REACT_APP_ANDROID_APP_LINK;
      } else if (deviceOS === DeviceOS.IOS) {
        redirectionLink = process.env.REACT_APP_IOS_APP_LINK;
      }
      if (redirectionLink) {
        window.location.href = redirectionLink
      }
    }
  };
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      {browserData && isMobileScreen && window.location.pathname !== "/resetpassword" ? (
        <CustomDialog
          TransitionComponent={Transition}
          onClose={() => handleClose(false)}
          aria-labelledby="customized-dialog-title"
          open={open}
          className={clsx(classes.dialogWrapper, classes.dialogWrapperBottom)}
          fullWidth={true}
        >
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => handleClose(false)}
          >
            <CloseIcon />
          </IconButton>
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            {t("OPEN_THIS_PAGE_IN")}...
          </DialogTitle>
          <DialogContent dividers>
            <CustomGrid container spacing={3} justifyContent="space-between">
              <CustomGrid item xs={7} className={classes.smartAppRow}>
                <img
                  width={30}
                  src={AppIcon}
                  className={classes.smartAppRowIcon}
                />
                {t("PRAISO_APP")}
              </CustomGrid>
              <CustomGrid item xs={5}>
                <CustomButton
                  fullWidth={true}
                  variant="contained"
                  color="primary"
                  onClick={() => navigateToApp()}
                  defaultrounded="true"
                >
                  {t("OPEN")}
                </CustomButton>
              </CustomGrid>
            </CustomGrid>
            <CustomGrid container spacing={3} justifyContent="space-between">
              <CustomGrid item xs={7} className={classes.smartAppRow}>
                <img
                  width={30}
                  src={browserData.icon}
                  className={classes.smartAppRowIcon}
                />
                {browserData.title}
              </CustomGrid>
              <CustomGrid item xs={5}>
                <CustomButton
                  fullWidth={true}
                  variant="contained"
                  color="secondary"
                  onClick={() => handleClose(false)}
                  defaultrounded="true"
                >
                  {t("CONTINUE")}
                </CustomButton>
              </CustomGrid>
            </CustomGrid>
          </DialogContent>
        </CustomDialog>
      ) : null}
    </>
  );
}
